import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Grid as VirtualizedGrid } from 'react-virtualized'

import styles from './grid-header.css'

const GridHeader = ({ items, width, height, cornerWidth, cellWidth, scrollLeft, cornerRenderer, headerRenderer }) => (
  <div styleName="container">
    <div styleName="corner">
      <VirtualizedGrid
        cellRenderer={cornerRenderer}
        columnCount={1}
        columnWidth={cornerWidth}
        height={height}
        rowCount={1}
        rowHeight={height}
        styleName="grid"
        width={cornerWidth}
      />
    </div>

    <div styleName="header">
      <VirtualizedGrid
        cellRenderer={headerRenderer}
        columnCount={items.count() + 1}
        columnWidth={cellWidth}
        height={height}
        rowCount={1}
        rowHeight={height}
        scrollLeft={scrollLeft}
        styleName="grid"
        width={width - cornerWidth}
      />
    </div>
  </div>
)

GridHeader.propTypes = {
  items: PropTypes.object.isRequired,
  width: PropTypes.number.isRequired,
  scrollLeft: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  cornerWidth: PropTypes.number.isRequired,
  cellWidth: PropTypes.number.isRequired,
  cornerRenderer: PropTypes.func.isRequired,
  headerRenderer: PropTypes.func.isRequired,
}

export default CSSModules(GridHeader, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-header/grid-header.js
 **/